export default __webpack_public_path__ + "static/media/ball.ddf6ca1e.png";